
import { CustomTranslation } from "@/utils/custom-translation";
import { TranslateResult } from "vue-i18n";
import AppTranslationInput from "@/components/TranslationInput.vue";
// import AppTextareaTranslationInput from "@/components/common/TextareaTranslationInput.vue";
import { CustomTranslationWithoutFallback } from "@/utils/custom-translation-without-fallback";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			translation: new CustomTranslationWithoutFallback()
		};
	},
	props: {
		title: [String, Object as ()=> TranslateResult],
		value: {
			type: Object as ()=>CustomTranslation,
			required: true
		},
		textarea: Boolean
	},
	watch: {
		value: {
			deep: true,
			immediate: true,
			handler(){
				this.translation = this.value.clone();
			}
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		submit(){
			this.$emit("input", this.translation);
			this.close();
		},
	},
	components: {
		AppTranslationInput,
		//AppTextareaTranslationInput
	}
});
